import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { last, map } from "lodash"
import OPTooltip from "components/material/tooltip"
import Logo from "components/logo"
import ServerNotifications from "modules/server-notifications"
import { LINK, PORTFOLIO } from "../../shapes"
import MobileNav from "../mobile-nav"
import PortfolioSelector from "../portfolio-selector"
import LegacySearch from "components/legacy-search"
import HelpMenu from "modules/help-menu"
import ThemeModeToggle from "components/theme-mode-toggle"
import ContextualMenu from "components/contextual-menu"
import { useSaveContextPreferences } from "hooks/preferences"
import PortfolioNavLink from "./portfolio-nav-link"

import "./style.scss"

export default function Nav({ account, portfolioName, links, latestPortfolios, modelId, navigationDisabled, menuItems }) {
  const saveLastLocationPreference = useSaveContextPreferences("navigation.root")

  const path = last(window.location.pathname.split("/"))

  return <div className="nav">
    {!navigationDisabled && <div className="left">
      <MobileNav links={links} portfolioName={portfolioName} home={`/${account}/home`} />
      <OPTooltip title="Go to resources page">
        <Link className="logo" to={`/${account}/home`}>
          <Logo />
        </Link>
      </OPTooltip>
      <ContextualMenu items={menuItems} />
      <PortfolioSelector portfolioName={portfolioName} latestPortfolios={latestPortfolios} />
      {map(links, link =>
        <PortfolioNavLink key={link.id} link={link} onSaveLastLocation={saveLastLocationPreference} />,
      )}
    </div>}
    <div className="center">
      <LegacySearch location={path} modelId={modelId} />
    </div>
    <div className="right">
      <div className="ai-button-spacer" />
      <ServerNotifications />
      <HelpMenu modelId={modelId} />
      <ThemeModeToggle inline iconButton={false} />
    </div>
  </div>
}

Nav.propTypes = {
  account: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(LINK).isRequired,
  portfolioName: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
  latestPortfolios: PropTypes.arrayOf(PORTFOLIO).isRequired,
  navigationDisabled: PropTypes.bool.isRequired,
  menuItems: PropTypes.array,
}
